import React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { useAuthenticationStore } from "../../../stores/auth";
import { AccountInfoBox } from "../components/AccountInfoBox";
import { TeacherSettings } from "../components/TeacherSettings";
import Grid from "@mui/material/Grid";
import { checkUserHasRole } from "../../auth/Utils";
import { Achievements } from "../components/Achievements";
import { withPageTracking } from "../../../services/postHog";
import { UserPreferences } from "../components/UserPreferences";
import { VerificationAndReferralStatus } from "../components/VerificationAndReferralStatus";
import { MarketingEmailPreferences } from "../components/MarketingEmailPreferences";

import SchoolSubscriptionSettings from "../components/SchoolSubscriptionSettings";

function Account({ showAchievements = false }) {
  // Temp hide the achievements
  const { user } = useAuthenticationStore();
  const activeContext = user?.info?.activeContext;
  const showMarketingEmailPreferences =
    activeContext?.contextType === "role_assignment" &&
    activeContext.hasApprovedSubscription === false &&
    Boolean(activeContext.roleAssignment?.school);
  return (
    <FruitifyContainer>
      <AccountInfoBox user={user} />
      <Grid container spacing={4} direction={"row"}>
        <Grid size={{ xs: 12, md: 6 }}>
          {checkUserHasRole({ user: user, role: "teacher" }) && (
            <TeacherSettings user={user} />
          )}
          <VerificationAndReferralStatus />
        </Grid>
        {showAchievements && (
          <Grid size={{ xs: 12, md: 6 }}>
            {checkUserHasRole({ user: user, role: "teacher" }) && (
              <Achievements />
            )}
          </Grid>
        )}
        {activeContext?.contextType === "role_assignment" &&
          activeContext.hasApprovedSubscription === false &&
          activeContext.roleAssignment?.role?.code === "teacher" &&
          activeContext.roleAssignment?.school && (
            <Grid size={{ xs: 12, md: 6 }}>
              <SchoolSubscriptionSettings
                key={`${activeContext.roleAssignment.id}:${activeContext.roleAssignment.school.id}`}
              />
            </Grid>
          )}
        <Grid size={{ xs: 12, md: 6 }}>
          <UserPreferences />
        </Grid>
        {showMarketingEmailPreferences && (
          <Grid size={{ xs: 12, md: 6 }}>
            <MarketingEmailPreferences user={user} />
          </Grid>
        )}
      </Grid>
    </FruitifyContainer>
  );
}

export default withPageTracking(Account, { feature: "account" });
